<template>
    <div class="pt435" id="pt435">
        <breadcrumb :navListCustom="[{title:$t('common.labels.myPgage'), routerName: pt435Init.myPage, param: {pageNo: '81'}}, {title:$t('pt435.labels.title'), routerName: '', param: {}}]"></breadcrumb>
        <div class="pt435-main section">
            <h2>{{$t('common.labels.myPgage')}}</h2>
            <div class="section-inner">
                <div class="errMessage">
                    <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt435'"/>
                </div>
                <h3 class="sendTitle" >{{$t('pt435.labels.title')}}</h3>
                <div class="sendSubTitle" v-if="isPagingDisplay">
                    <p class="mb32">{{$t('pt435.labels.msg')}}</p>
                </div>
                <div v-else>
                    <p class="mb32">
                        {{$t('pt435.labels.messgNoResult')}}
                    </p>
                    <!-- 新規配送先追加 -->
                    <template v-if="!pt435Init.tdkMaxFlg">
                        <p>
                            <input class="submit-button-small" type="submit" :value="$t('pt435.buttons.tdkInsert')" @click="doInsert()">
                        </p>
                    </template>
                </div>
                <div v-if="isPagingDisplay">
                    <page-feed
                        :isDisplay="isPagingDisplay"
                        :pageFeedData="pageFeedData"
                        :orderByType="ptOrderByType"
                        :dispPageSizeList="dispPageSizeList"
                        :isDisplaySort="false"
                        @search="changeSearch"
                        >
                        <template slot="othersButton">
                            <!-- 新規配送先追加 -->
                            <input v-if="!pt435Init.tdkMaxFlg" class="submit-button-small" type="submit" :value="$t('pt435.buttons.tdkInsert')" @click="doInsert()">
                            <!-- 一括削除 -->
                            <input class="submit-button-small02" type="submit" :value="$t('pt435.buttons.tdkDelete')" @click="confirmdoDeleteAll()">
                        </template>
                        <template slot="TableRender">
                            <div class="sendInfo" v-if="getLengthObj(pt435Init.tdkList) > 0">
                                <!--page table -->
                                <table class="sendTbl" >
                                    <thead>
                                        <!-- No. -->
                                        <th scope="col" class="w80">{{$t('common.labels.no')}}</th>
                                        <!-- 送主名 -->
                                        <th scope="col" class="w160">{{$t('pt435.labels.deliName')}}</th>
                                        <!-- 送主住所 -->
                                        <th scope="col">{{$t('pt435.labels.tdkAddress')}}</th>
                                        <!-- 操作 -->
                                        <th scope="col" class="w80">{{$t('pt435.labels.operation')}}</th>
                                        <!-- 表示順 -->
                                        <th v-if="pt435Init.sortNoFlg == 1" scope="col" class="w80" style="white-space:nowrap;">{{$t('pt435.labels.sortNo')}}</th>
                                    </thead>
                                    <tbody>
                                        <tr class="sendRow" v-for="(item, index) in pt435Init.tdkList" :key="index">
                                            <!-- No. -->
                                            <td class="sendNo" scope="row" :aria-label="$t('common.labels.no')">
                                                {{pageFeedData.fromRecord+index}}
                                            </td>
                                            <!-- 送主名 -->
                                            <td class="sendNm" scope="row" :aria-label="$t('pt435.labels.deliName')">
                                                {{item.TDK_NM1}}&nbsp;{{item.TDK_NM2}}
                                            </td>
                                            <!-- 送主住所 -->
                                            <td class="sendAdd" scope="row" :aria-label="$t('pt435.labels.tdkAddress')">
                                                {{$t('pt435.labels.zip')}}{{item.TDK_ZIP}}<br>
                                                {{item.KEN_NM}}{{item.TDK_ADDR1}}<br>
                                                {{item.TDK_ADDR2}}<br>
                                                {{item.TDK_ADDR3}}
                                            </td>
                                            <td class="sendOptBtn">
                                                <!-- 変更 -->
                                                <input type="button" @click="doDetail(item.TDK_M_SEQ)" :value="$t('common.buttons.change')">
                                                <br>
                                                <span class="button-mt10">
                                                    <!--削除-->
                                                    <input class="submit-button2" type="button" @click="confirmdoDelete(item.TDK_M_SEQ)" :value="$t('common.buttons.delete')">
                                                </span>
                                            </td>
                                            <!-- 表示順 -->
                                            <td v-if="pt435Init.sortNoFlg == 1" class="cart-num" scope="row" :aria-label="$t('pt435.labels.sortNo')" style="text-align:center;">
                                                <input type="text" maxlength="5" :id="'sortNo_' + index" v-model="item.SORT_NO" @input="item.SORT_NO = sanitizeSortNo(item.SORT_NO)" style="width:60px; text-align:center;">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--表示順更新ボタン-->
                                <div v-if="pt435Init.sortNoFlg == 1" style="text-align:right; margin-top:8px; margin-bottom:16px;">
                                    <input class="submit-button-small" type="button" :value="$t('pt435.buttons.sortNoUpdate')" @click="doUpdate()">
                                </div>
                            </div>
                        </template>
                    </page-feed> 
                </div>
                <!--戻るボタン-->
                <div class="btnLabel" id="btn_roll3" v-if="pt435Init.backButtonFlg == 1">
                    <router-link :to="generateLinkParams(81,pt435Init.myPage)" class="submit-button-back">
                        {{$t('common.buttons.return')}}
                    </router-link>
                </div>
            </div>
        </div>
        <!-- modal confirm area -->
        <alert-confirm 
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :okAction="doAction"
            :isButtonCancel="isButtonCancel">
        </alert-confirm>
    </div>
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import PageFeed from "../commonParts/PageFeedTdk";
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import AlertConfirm from 'components/AlertConfirm';
import EventBus from 'assets/js/eventBus';
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
};

export default {
    /*
    * Name of component
    */
    name: "PT435MemberSendListParts",
    /* 
    * Declare components
    */
    components: {
        PageFeed,
        InputNumber,
        AlertConfirm,
        Breadcrumb,
        Message
    },
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isPagingDisplay: false,
            pt435ReqModel: {
                sItemNo: null,
                orderType: 0,
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 10,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt435Init: {
                pageNo: null,
                pageSize: null,
                tdkList: {},
                tdkMaxFlg: false,
                backButtonFlg: 0
            },
            queryData:null,
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },
            dispPageSizeList:[
                {value: 10,text: "10行"},
                {value: 15,text: "15行"},
                {value: 30,text: "30行"},
                {value: 45,text: "45行"},
                {value: 50,text: "50行"},
                {value: 100,text: "100行"}
            ],
            SiteConstants: SiteConstants,
            site: "",
            isModalShow:false,
            msgConfirm:'',
            isButtonCancel: true,
            actionFlg:0,
            tdkNo:0,
            listMessValid:[],
            mapMessValid:[],
            listIdErr:[]
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            _this.pt435Init = _this.ptInitData;
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT435 + _this.$UrlConstants.DO_INIT, _this.pt435ReqModel).then(function(response) {
                _this.pt435Init = response.data;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        // 未ログインの場合
        if (_this.pt435Init.isLogin == false) {
            // ログイン画面へ遷移
            const parameter = _this.generateLinkParams(18,_this.pt435Init.loginPage,{returnFlg: 1, fromMyPage: 1});
            _this.$router.push(parameter);
        // ログイン済の場合
        } else {
            _this.getDataForPageFeed(_this.pt435Init);
        }

        //close pupup
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        // 個別削除
        confirmdoDelete: function(tdkNo){
            this.msgConfirm = this.$i18n.t('pt435.labels.messg1')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 1;
            this.tdkNo = tdkNo;
            
        },
        // 全削除
        confirmdoDeleteAll: function(){
            this.msgConfirm = this.$i18n.t('pt435.labels.messg2')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 1;
            this.tdkNo = 0;
        },
        /**
         * delete favorite product
         * @param {String} tdkNo, item product
         */
        doDelete: function(){
            var _this = this;
            _this.pt435ReqModel.tdkNo = this.tdkNo;
            _this.$emit("event-loading", true);
            // api
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT435 + _this.$UrlConstants.DO_DELETE, _this.pt435ReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    // ログイン画面へ遷移
                    const parameter = _this.generateLinkParams(18,_this.pt435Init.loginPage);
                    _this.$router.push(parameter);
                }else{
                    _this.pt435Init = response.data;
                    _this.getDataForPageFeed(response.data);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /**
         * delete favorite product
         * go to pt410MemberTdkDetails
         */
        doInsert: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            const parameter = _this.generateLinkParams(103,_this.pt435Init.okuriPage);
            _this.$router.push(parameter);
        },
        /**
         * delete favorite product
         * @param {String} tdkMSeq, tdk product
         */
        doDetail: function(tdkMSeq){
            var _this = this;
            _this.$emit("event-loading", true);
            const parameter = _this.generateLinkParams(103,_this.pt435Init.okuriPage,{tdkMSeq:tdkMSeq},{tdkMSeq: tdkMSeq, ptPageNo: _this.pt435ReqModel.pageNo, ptPageSize: _this.pt435ReqModel.pageSize});
            _this.$router.push(parameter);
        },
        /**
         * update sort no
         * send sort number list to server and refresh
         */
        doUpdate: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, 'pt435');
            // 赤枠リセット
            _this.pt435Init.tdkList.forEach(function(item, idx) {
                var el = document.getElementById('sortNo_' + idx);
                if (el) { el.style.borderColor = ''; }
            });
            _this.pt435ReqModel.okuriSortList = _this.pt435Init.tdkList.map(function(item) {
                return { tdkMSeq: item.TDK_M_SEQ, sortNo: item.SORT_NO !== '' && item.SORT_NO != null ? item.SORT_NO : null };
            });
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT435 + _this.$UrlConstants.DO_UPDATE, _this.pt435ReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    const parameter = _this.generateLinkParams(18,_this.pt435Init.loginPage);
                    _this.$router.push(parameter);
                }else{
                    _this.pt435Init = response.data;
                    _this.getDataForPageFeed(response.data);
                    toastr.success(_this.$i18n.t('pt435.labels.sortNoUpdateSuccess'));
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined && error.response != null && error.response != undefined){
                    if(406 == error.response.status){
                        var resultValid = common.excuteValidationEcSite(error, 'pt435');
                        if(resultValid){
                            _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                            _this.listMessValid = resultValid.msgList;
                            _this.mapMessValid = resultValid.mapMsg;
                        }
                    }else{
                        common.errorAPI(error);
                    }
                }
                common.scrollTop();
            });
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {},additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        /*
        *  execute update or delete or insert
        */
        doAction: function(){
            switch (this.actionFlg) {
                case 1:
                    this.doDelete();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            this.isModalShow = false;
            this.actionFlg = 0;
            this.isButtonCancel = true;
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        sanitizeSortNo: function(value) {
            if (value == null) {
                return '';
            }
            var sortNo = String(value).replace(/[^0-9-]/g, '');
            if (sortNo.indexOf('-') === 0) {
                return '-' + sortNo.slice(1).replace(/-/g, '');
            }
            return sortNo.replace(/-/g, '');
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.pt435ReqModel.pageSize = pageSize;
            this.pt435ReqModel.pageNo = pageNo;
            this.pt435ReqModel.orderType = sortNo;
            var queryString = this.getQueryString(pageSize, 'ptPageSize');
            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            location.href = appPath + this.$route.path + '?' + queryString;
        },
        /**
         * get page size, page no
         * @param {Number} val
         * @param {String} type
         */
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.pt435ReqModel.pageNo;
            query.ptPageSize = this.pt435ReqModel.pageSize;
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /**
         * get data for page feed
         * @param {Object} data, data from API
         */
        getDataForPageFeed: function(data) {
            var _this = this;
            _this.pageFeedData.totalRecord = data.totalRecord;
            _this.pageFeedData.fromRecord = data.fromRecord;
            _this.pageFeedData.toRecord = data.toRecord;
            _this.pageFeedData.pageSize = data.pageSize;
            _this.pageFeedData.pageNo = data.pageNo;
            _this.initQueryData();

            if(_this.pt435Init.tdkList.length > 0){
                _this.isPagingDisplay = true;
            }else{
                _this.isPagingDisplay = false;
            }
        },

        initQueryData() {
            this.queryData = this.$route.query;
            if(this.queryData) {
                if(this.queryData.ptPageNo) {
                    this.pt435ReqModel.pageNo = this.queryData.ptPageNo;
                    this.pageFeedData.pageNo = this.queryData.ptPageNo;
                }
                if(this.queryData.ptPageSize) {
                    this.pt435ReqModel.pageSize = this.queryData.ptPageSize;
                    this.pageFeedData.pageSize = this.queryData.ptPageSize;
                }
            }
        }
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        this.initQueryData();
    }
}
</script>
